<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/po/receipts">{{ $t('purchase_payment') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">[{{header.Num}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <template v-if="model.Status=='Draft'">
                <router-link :to="{ name: 'purchase_receipt_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onApproval"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
            </template>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <th style="width: 120px;">{{$t('date')}}</th>
                                        <th style="width: 10px;">:</th>
                                        <td>{{$format(header.Date,'DD/MM/YYYY')}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('code')}}</th>
                                        <th>:</th>
                                        <td>{{header.Num}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('payment_menthod')}}</th>
                                        <th>:</th>
                                        <td>{{header.PaidMethod}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('ref_num')}}</th>
                                        <th>:</th>
                                        <td>{{header.PurchaseNum}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('amount')}}</th>
                                        <th>:</th>
                                        <td>{{$money(header.Amount)}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('description')}}</th>
                                        <th>:</th>
                                        <td>{{header.Description}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                header: {}
            }
        },
        created: function(){
            this.findById(this.$route.params.id);
        },
        methods: {
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('po/receipt/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Data;
                        this.header = res.data.Data;
                    }
                }).finally(function(){ loading.hide(); });
            },
            onApproval(){
                let id = this.$route.params.id;
                let loading = this.$loading.show();
                this.$api().post('po/receipt/approval', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/po/receipts');
                    }
                }).finally(function(){ loading.hide(); });
            }
        },
    }
</script>
